import { render, staticRenderFns } from "./TransformIconGroupCardItem.vue?vue&type=template&id=3132ea6a&scoped=true&"
import script from "./TransformIconGroupCardItem.vue?vue&type=script&lang=js&"
export * from "./TransformIconGroupCardItem.vue?vue&type=script&lang=js&"
import style0 from "./TransformIconGroupCardItem.vue?vue&type=style&index=0&id=3132ea6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132ea6a",
  null
  
)

export default component.exports